import React from 'react'

import {
  createComplex,
  fetchClusters,
  fetchComplexes,
  updateComplex
} from 'api/apartment'

import ApartmentApiCrudPage from '../shared/ApartmentApiCrudPage'

const columns = [
  { name: 'name', label: 'Apartment' },
  { name: 'slug', label: 'Slug', options: { filter: false } },
  { name: 'clusterName', label: 'Cluster' },
  { name: 'status', label: 'Status' },
  {
    name: 'payout_share_percent',
    label: 'Payout %',
    options: { filter: false }
  },
  { name: 'go_live_date', label: 'Go-live', options: { filter: false } }
]

const ApartmentComplexes = () => {
  const [clusters, setClusters] = React.useState([])
  React.useEffect(() => {
    fetchClusters()
      .then(setClusters)
      .catch(() => {})
  }, [])

  const fields = [
    { name: 'name', label: 'Apartment Name', type: 'text' },
    {
      name: 'clusterSlug',
      label: 'Cluster',
      type: 'select',
      options: clusters.map((c) => ({ value: c.slug, label: c.name }))
    },
    { name: 'address', label: 'Address', type: 'textarea' },
    {
      name: 'status',
      label: 'Status',
      type: 'select',
      options: ['Active', 'Inactive']
    },
    {
      name: 'payout_share_percent',
      label: 'Apartment Payout %',
      type: 'number'
    },
    { name: 'go_live_date', label: 'Go-live Date', type: 'date' }
  ]

  const rowToForm = (row) => ({
    ...row,
    clusterSlug:
      (clusters.find((c) => c.name === row.clusterName) || {}).slug || ''
  })

  return (
    <ApartmentApiCrudPage
      title="Apartments"
      tableTitle="Apartments"
      entityLabel="Apartment"
      subtitle="Apartment communities"
      showSelector={false}
      fetchList={fetchComplexes}
      createItem={createComplex}
      updateItem={updateComplex}
      idOf={(row) => row.slug}
      columns={columns}
      fields={fields}
      rowToForm={rowToForm}
      emptyValues={{
        name: '',
        clusterSlug: '',
        address: '',
        status: 'Active',
        payout_share_percent: 15,
        go_live_date: ''
      }}
    />
  )
}

export default ApartmentComplexes
